import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import useDidMountEffect from '../utils/useDidMountEffect';
import currency from 'currency.js';
import { CircularProgress } from '@mui/material';

const MyFund = ({
    setTotal,
    viewType,
    setSubscriptionTotal,
    subscriptionTotal,
    setPpvTotal,
    ppvTotal,
    setReferralTotal,
    referralTotal,
    setTipsTotal,
    tipsTotal,
    setChargebackTotal,
    chargebackTotal,
    fundTotal
}) => {
    const [myFunds, setMyFunds] = useState({});
    const [busy, setBusy] = useState(false);
    const [fundKeys, setFundKeys] = useState([]);

    const getMyFunds = () => {
        setBusy(true);
        axios.get('/api/performances/my-funds')
            .then(response => {
                setMyFunds((response.data));
            })
            .catch(error => { })
            .finally(() => {
                setBusy(false);
            });
    };

    useEffect(() => {
        getMyFunds();
    }, []);

    useDidMountEffect(() => {
        setFundKeys(Object.keys(myFunds));
    }, [myFunds]);

    useDidMountEffect(() => {
        if (fundKeys.length > 0) {
            let tempTotal = 0;
            let tempSubscription = 0;
            let tempTips = 0;
            let tempPpv = 0;
            let tempReferral = 0;
            let tempChargeback = 0;

            fundKeys.forEach(fundKey => {
                tempTotal += myFunds[fundKey].reduce((sum, fund) => {
                    if (fund.transaction_type != 'chargeback') {
                        return sum += fund.total == null ? 0 : parseFloat(fund.total);
                    }
                    return sum -= fund.total == null ? 0 : parseFloat(fund.total);
                }, 0);
                setTotal(tempTotal);

                tempSubscription += myFunds[fundKey].reduce((sum, fund) => {
                    if (fund.transaction_type == 'subscription') {
                        return sum += fund.total == null ? 0 : parseFloat(fund.total);
                    }
                    return sum;
                }, 0);
                setSubscriptionTotal(tempSubscription);

                tempTips += myFunds[fundKey].reduce((sum, fund) => {
                    if (fund.transaction_type == 'Send tip') {
                        return sum += fund.total == null ? 0 : parseFloat(fund.total);
                    }
                    return sum;
                }, 0);
                setTipsTotal(tempTips);

                tempPpv += myFunds[fundKey].reduce((sum, fund) => {
                    if (fund.transaction_type == 'PPV') {
                        return sum += fund.total == null ? 0 : parseFloat(fund.total);
                    }
                    return sum;
                }, 0);
                setPpvTotal(tempPpv);

                tempReferral += myFunds[fundKey].reduce((sum, fund) => {
                    if (fund.transaction_type == 'referral') {
                        return sum += fund.total == null ? 0 : parseFloat(fund.total);
                    }
                    return sum;
                }, 0);
                setReferralTotal(tempReferral);

                tempChargeback += myFunds[fundKey].reduce((sum, fund) => {
                    if (fund.transaction_type == 'chargeback') {
                        return sum += fund.total == null ? 0 : parseFloat(fund.total);
                    }
                    return sum;
                }, 0);
                setChargebackTotal(tempChargeback);
            });
        }
    }, [fundKeys]);

    return (
        <React.Fragment>
            {
                <div className='table-responsive-sm'>
                    <table className="table table-sm">
                        {
                            viewType === 'summary' && <thead className="sticky white-bg">
                                <tr>
                                    <th style={{ textAlign: 'left', verticalAlign: 'top', border: 0 }}>Total Earnings</th>
                                    <th style={{ textAlign: 'right', border: 0 }}>
                                        {currency(parseFloat(fundTotal)).format()}
                                        <br />
                                        <strong>Total</strong>
                                    </th>
                                </tr>
                            </thead>
                        }

                        {
                            viewType === 'details' && <thead>
                                <tr style={{ backgroundColor: '#e5f5fd', border: 0 }}>
                                    <th colSpan="6" style={{ border: 0 }}>Total Earnings</th>
                                </tr>
                                <tr style={{ backgroundColor: '#e5f5fd', border: 0 }}>
                                    <th width="16.6%" style={{ border: 0 }}></th>
                                    <th width="16.6%" style={{ border: 0 }}>
                                        {currency(subscriptionTotal).format({ precision: 2 })}
                                    </th>
                                    <th width="16.6%" style={{ border: 0 }}>
                                        {currency(tipsTotal).format({ precision: 2 })}
                                    </th>
                                    <th width="16.6%" style={{ border: 0 }}>
                                        {currency(ppvTotal).format({ precision: 2 })}
                                    </th>
                                    <th width="16.6%" style={{ border: 0 }}>
                                        {currency(referralTotal).format({ precision: 2 })}
                                    </th>
                                    {/* <th style={{ border: 0 }}>
                                        {currency(chargebackTotal).format({precision: 2})}
                                    </th> */}
                                    <th width="16.6%" style={{ textAlign: 'right', border: 0 }}>
                                        {currency(fundTotal).format({ precision: 2 })}
                                    </th>
                                </tr>
                                <tr>
                                    <th></th>
                                    <th>Subscriptions</th>
                                    <th>Tips</th>
                                    <th>PPVs</th>
                                    <th>Referrals</th>
                                    {/* <th>Chargebacks</th> */}
                                    <th style={{ textAlign: 'right' }}>Total</th>
                                </tr>
                            </thead>
                        }
                        <tbody>
                            {
                                fundKeys.length > 0
                                    ? fundKeys.map((fundKey, index) => {
                                        if (viewType === 'summary') {
                                            return <tr key={`${fundKey}-${index}`}>
                                                <td>
                                                    {moment(fundKey).format('MMM YYYY')}
                                                </td>
                                                <td align='right'>
                                                    {
                                                        currency(myFunds[fundKey].reduce((sum, fund) => {
                                                            if (fund.transaction_type != 'chargeback') {
                                                                return sum += !fund.total ? 0 : parseFloat(fund.total);
                                                            }
                                                            return sum -= !fund.total ? 0 : parseFloat(fund.total);
                                                        }, 0)).format({ precision: 2 })
                                                    }
                                                </td>
                                            </tr>;
                                        } else {
                                            return <React.Fragment>
                                                <tr key={`${fundKey}-${index}`}>
                                                    <td colSpan={7} align='left'>
                                                        <b>{moment(fundKey).format('MMM YYYY')}</b>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td style={{ border: 0 }}>
                                                        <span style={{ display: 'none' }}>{moment(fundKey).format('MMM YYYY')}</span>
                                                    </td>
                                                    <td style={{ border: 0 }}>
                                                        {
                                                            currency(myFunds[fundKey].findIndex(f => f.transaction_type == 'subscription') >= 0 ? myFunds[fundKey][myFunds[fundKey].findIndex(f => f.transaction_type == 'subscription')].total : 0).format()
                                                        }
                                                    </td>
                                                    <td style={{ border: 0 }}>
                                                        {
                                                            currency(myFunds[fundKey].findIndex(f => f.transaction_type == 'Send tip') >= 0 ? myFunds[fundKey][myFunds[fundKey].findIndex(f => f.transaction_type == 'Send tip')].total : 0).format()
                                                        }
                                                    </td>
                                                    <td style={{ border: 0 }}>
                                                        {
                                                            currency(myFunds[fundKey].findIndex(f => f.transaction_type == 'PPV') >= 0 ? myFunds[fundKey][myFunds[fundKey].findIndex(f => f.transaction_type == 'PPV')].total : 0).format()
                                                        }
                                                    </td>
                                                    <td style={{ border: 0 }}>
                                                        {
                                                            currency(myFunds[fundKey].reduce((sum, fund) => {
                                                                if (fund.transaction_type == 'referral') {
                                                                    return sum += !fund.total ? 0 : parseFloat(fund.total);
                                                                }

                                                                return sum;
                                                            }, 0)).format()
                                                        }
                                                    </td>
                                                    {/* <td style={{ border: 0 }}>
                                                        {
                                                            currency(myFunds[fundKey].reduce((sum, fund) => {
                                                                if (fund.transaction_type != 'chargeback') {
                                                                    return sum += !fund.total ? 0 : parseFloat(fund.total)
                                                                }
                                                                return sum -= !fund.total ? 0 : parseFloat(fund.total)
                                                            }, 0)).format()
                                                        }
                                                    </td> */}
                                                    <td align='right' style={{ border: 0 }}>
                                                        {
                                                            currency(myFunds[fundKey].reduce((sum, fund) => {
                                                                if (fund.transaction_type != 'chargeback') {
                                                                    return sum += !fund.total ? 0 : parseFloat(fund.total);
                                                                }
                                                                return sum -= !fund.total ? 0 : parseFloat(fund.total);
                                                            }, 0)).format()
                                                        }
                                                    </td>
                                                </tr>
                                            </React.Fragment>;
                                        }
                                    })

                                    : <tr>
                                        <td align="center" colSpan="6">
                                            <CircularProgress size={20} />
                                        </td>
                                    </tr>
                            }
                        </tbody>
                    </table>
                </div>
            }

        </React.Fragment>
    );
};

export default MyFund;
